import { BotDataManagerType, HomeDataManagerType, HomeDataStyle } from '@/const/promotion';

import { IStory } from './../store/modules/__endpoints__/module';
import { RichMediaValue } from './media';
import { IBot, ISpace } from './module';

export interface IPromotionOutput {
  name?: string;
  itemList?: IPromotionItemOutput[];
  id?: string;
}

export interface IPlazaOutput {
  name?: string;
  itemList?: IPlazaItemOutput[];
  id?: string;
}

export interface IPromotionInput {
  name?: string;
  itemList?: { id: string }[];
  id?: string;
}

export type IPlazaInput = IPromotionInput;

export interface IPromotionItemOutput {
  managerType?: HomeDataManagerType;
  style?: HomeDataStyle;
  id?: string;
  homeDataId?: string;
  roleSquareId?: string;
  banner?: ItemManage;
  collection?: ItemManage;
  rank?: ItemManage;
  recommendStory?: ItemManage;
  materialMap?: Record<string, string>;
  stories?: Story;
  space?: ISpace;
  topNum?: number
  bots?: Bot;
  officialActivity?: OfficialActivity;
}

export interface IPlazaItemOutput {
  managerType?: BotDataManagerType;
  id?: string;
  style?: HomeDataStyle;
  banner?: ItemManage;
  collection?: ItemManage;
  accordion?: ItemManage;
  materialMap?: Record<string, string>;
  bots?: Bot;
  space?: ISpace;
  topNum?: number
  roleSquareId?: string;
}

export interface ItemManage {
  name?: string;
  space?: ISpace;
  topNum?: number;
  intro?: string;
  bots?: {
    bot?: IBot;
    bgImage?: RichMediaValue;
    bgVideo?: RichMediaValue;
    leftLabel?: Label;
    rightLabel?: Label;
  }[];
  stories?: {
    story?: IStory;
    bgImage?: RichMediaValue;
    bgVideo?: RichMediaValue;
    leftLabel?: Label;
    rightLabel?: Label;
  }[];
  story?: IStory;
  bgImage?: RichMediaValue
}

export enum CollectionSortType {
  COLLECTIONSORTTYPE_POPULARITY = 1,
}

export interface ISubCollection {
  name: string;
  desc: string,
  sortType: CollectionSortType;
  stories: IStory[]
}

export interface IPromotionItemInput {
  stories?: Story;
  name?: string;
  managerType?: HomeDataManagerType;
  style?: HomeDataStyle;
  space?: ISpace;
  materialMap?: Record<string, string>;
  id?: string;
  homeDataId?: string;
  topNum?: number;
  bgImage?: RichMediaValue;
  bots?: Bot;
  multiCollection?: ISubCollection[];
  officialActivity?: OfficialActivity;
}

export interface IPlazaItemInput {
  stories?: Story;
  bots?: Bot;
  name?: string;
  intro?: string;
  managerType?: BotDataManagerType;
  style?: HomeDataStyle;
  space?: ISpace;
  materialMap?: Record<string, string>;
  id?: string;
  roleSquareId?: string;
  topNum?: number;
  bgImage?: RichMediaValue;
}

export interface Story {
  story?: IStory[];
  others?: OthersData[];
}

export interface Bot {
  bots?: IBot[];
  others?: OthersData[];
}

export interface IPromotionEvent {
  [key: string]: any
}

export interface Label {
  icon?: RichMediaValue;
  text?: string;
}
export interface OthersData {
  id?: string;
  bgImage?: RichMediaValue;
  bgVideo?: RichMediaValue;
  leftLabel?: Label;
  rightLabel?: Label;
}

export enum ActivityType {
  DEFAULT = 0,
  QQGROUP = 1,
  H5 = 2,
}

export interface OfficialActivity {
  logo: RichMediaValue;
  title: string;
  subTitle: string;
  buttonName: string;
  type: ActivityType;
  qqGroup?: ActivityQQGroup;
  h5?: ActivityH5;
}

export interface ActivityQQGroup {
  qq: string;
  url: string;
}

export interface ActivityH5 {
  url: string;
}
